import { ISigningCase } from 'src/models';
import {
  isSigningCaseRejected,
  isSigningCaseReadyToSign,
  isSigningCaseSigned,
  isSigningCaseWaiting,
} from 'src/utils/SigningCase';
import {
  bluePrimary,
  darkGreenPrimary,
  darkOrangePrimary,
  darkRedPrimary,
  mvpBlue,
  mvpBlueText,
  mvpGreenPrimary,
  mvpGreenText,
  mvpRedPrimary,
  mvpRedText,
  mvpYellowPrimary,
  mvpYellowText,
} from 'src/styles';

export const getSigningCaseHeaderColor = (status: ISigningCase['status']) => {
  if (isSigningCaseReadyToSign(status)) {
    return bluePrimary;
  } else if (isSigningCaseRejected(status)) {
    return darkRedPrimary;
  } else if (isSigningCaseSigned(status)) {
    return darkGreenPrimary;
  } else if (isSigningCaseWaiting(status)) {
    return darkOrangePrimary;
  }

  return bluePrimary;
};

export const getMvpAppSigningCaseHeaderColor = (
  status: ISigningCase['status']
) => {
  if (isSigningCaseReadyToSign(status)) {
    return mvpBlue;
  } else if (isSigningCaseRejected(status)) {
    return mvpRedPrimary;
  } else if (isSigningCaseSigned(status)) {
    return mvpGreenPrimary;
  } else if (isSigningCaseWaiting(status)) {
    return mvpYellowPrimary;
  }

  return bluePrimary;
};

export const getMvpAppSigningCaseFontColor = (
  status: ISigningCase['status']
) => {
  if (isSigningCaseReadyToSign(status)) {
    return mvpBlueText;
  } else if (isSigningCaseRejected(status)) {
    return mvpRedText;
  } else if (isSigningCaseSigned(status)) {
    return mvpGreenText;
  } else if (isSigningCaseWaiting(status)) {
    return mvpYellowText;
  }

  return bluePrimary;
};
